var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 17.6H6.4V12.8H10.4V8.8H15.2V12.8H19.2V17.6H15.2V21.6H10.4V17.6ZM12.8 0L0 4.8V14.544C0 22.624 5.456 30.16 12.8 32C20.144 30.16 25.6 22.624 25.6 14.544V4.8L12.8 0ZM22.4 14.544C22.4 20.944 18.32 26.864 12.8 28.672C7.28 26.864 3.2 20.96 3.2 14.544V7.024L12.8 3.424L22.4 7.024V14.544Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.66a89e564a9a6eba62bfb407ea9601c1.svg";
export { ForwardRef as ReactComponent };